export const truncateExcerpt = (excerpt: string, maxLength: number) => {
  if (!excerpt) return "";

  // If the excerpt is shorter than the max length, return it as is
  if (excerpt.length <= maxLength) return excerpt;

  // Find the last space within the max length
  const truncated = excerpt.slice(0, maxLength);
  const lastSpaceIndex = truncated.lastIndexOf(" ");

  // If there's no space within the max length, return truncated string with ellipsis
  if (lastSpaceIndex === -1) return truncated + "...";

  // Otherwise, return truncated string up to the last space with ellipsis
  return truncated.slice(0, lastSpaceIndex) + "...";
};
